import { post } from "../index";

export function speechUpload(body) {
  return post(`/speech/file`, body);
}
